import { useEffect, useMemo, useState } from "react";
import { Grid } from "@material-ui/core";
import { RootState, RootDispatch } from "../../model";
import { useRematch } from "../../utils/useRematch";
import logo from "../../assets/logo-white.svg";
// import roleVSloot from "../../assets/roleVSloot.svg";
import profession from "../../assets/profession.svg";
import discord from "../../assets/discord.svg";
import twitter from "../../assets/twitter.svg";
import VS from "../../assets/vs.jpeg";
import gender from "../../assets/gender.svg";
import skill from "../../assets/skill.svg";
import "./index.less";

const genderOptions = [
  { value: 0, text: "Male" },
  { value: 1, text: "Female" },
  { value: 2, text: "Unknown" },
];
const raceOptions = [
  { value: 0, text: "Human" },
  { value: 1, text: "Elf" },
  { value: 2, text: "Orc" },
  { value: 3, text: "Undead" },
  { value: 4, text: "Demons" },
  { value: 5, text: "Deity" },
];
const alignmentOptions = [
  { value: 0, text: "Lawful Good" },
  { value: 1, text: "Neutral Good" },
  { value: 2, text: "Chaotic Good" },
  { value: 3, text: "Lawful Neutral" },
  { value: 4, text: "Neutral" },
  { value: 5, text: "Chaotic Neutral" },
  { value: 6, text: "Lawful Evil" },
  { value: 7, text: "Neutral Evil" },
  { value: 8, text: "Chaotic Evil" },
];

type point =
  | "strength"
  | "dexterity"
  | "constitution"
  | "charisma"
  | "intelligence"
  | "wisdom";

interface Attributes {
  tokenId?: number;
  gender?: number;
  race?: number;
  alignment?: number;
  point: {
    strength: number;
    dexterity: number;
    constitution: number;
    charisma: number;
    intelligence: number;
    wisdom: number;
  };
}

const fixPointOrder = [
  "strength",
  "dexterity",
  "constitution",
  "charisma",
  "intelligence",
  "wisdom",
];

function getRandom(min: number, max: number) {
  const num = Math.floor(Math.random() * (max - min + 1) + min);
  return num;
}

function randomSort(a: any, b: any) {
  return Math.random() > 0.5 ? -1 : 1;
}

const mapState = (state: RootState) => ({
  ...state.main,
  loading: state.loading,
});

const mapDispatch = (dispatch: RootDispatch) => ({
  ...dispatch.main,
});

export default function Index() {
  const [{ userInfo, loading }, { init, claim }] = useRematch(
    mapState,
    mapDispatch
  );

  const [attributes, setAttributes] = useState<Attributes>({
    point: {
      strength: 0,
      dexterity: 0,
      constitution: 0,
      charisma: 0,
      intelligence: 0,
      wisdom: 0,
    },
  });

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const currentPoint = useMemo(() => {
    // let keyList = Object.keys(attributes.point)
    let total = 0;
    Object.keys(attributes.point).forEach((key) => {
      total = total + attributes.point[key as point];
    });
    return total;
  }, [attributes]);

  const randomAttr = () => {
    const gender = genderOptions[getRandom(0, genderOptions.length - 1)].value;
    const race = raceOptions[getRandom(0, raceOptions.length - 1)].value;
    const alignment =
      alignmentOptions[getRandom(0, alignmentOptions.length - 1)].value;
    let attrValueList = 30;
    let pointAttrValue = {} as any;
    let keys = Object.keys(attributes.point);
    keys.sort(randomSort);
    keys.forEach((pointKey, index) => {
      let i = getRandom(0, attrValueList);
      attrValueList = attrValueList - i;
      pointAttrValue[pointKey] = Number(i);
    });
    let randomTokenId = getRandom(1, 9800);
    setAttributes({
      tokenId: randomTokenId,
      gender,
      race,
      alignment,
      point: {
        ...pointAttrValue,
      },
    });
  };

  return (
    <div className="index">
      <div className="main">
        <Grid container spacing={2}>
          <Grid item md={6} xs={12}>
            <div className="desc">
              <div className="slogan">
                Role is a seed, a seed account for Metaverse Game.
                <div className="vs-img">
                  <img src={VS} width="100%" alt="" />
                </div>
              </div>
              <p className="para">
                <span className="serial">
                  What is the difference between [Role] and [Loot]?
                </span>
                <br />
                <span className="serial">Ⅰ.</span>Role is the account character,
                and Loot is the equipment worn by the character.
              </p>
              <p className="para">
                <span className="serial">Ⅱ.</span>Role is created by users,
                while Loot is officially generated.
                <br />
                With Role, players can choose their own gender, basic attributes
                (strength/dexterity, etc.), race, and alignment. Occupations
                (Warrior/Mage/Dragon Knight, etc.) and traits are randomly
                generated by the contract. Players can create their own stories,
                interpret the characters according to their traits and
                occupations.
              </p>
              <div className="profession-img">
                <img src={profession} width="60%" alt="" />
              </div>
              <p className="para">
                About Role: <br />
                0. The mode of this project learned a lot from Dungeons &
                Dragons (DND). <br />
                1. Role has 3 genders, 6 basic attributes, 6 races, 9 alignment,
                8 core professions, and 300 seed professions. <br />
                2. There are a total of 10,000 Roles, of which 9,800 can be
                collected for free (Token ID：1-9800), and 200 belong to the
                development team. <br />
                3. Role will charge 3% of the secondary royalties. Loot opened
                the era of NFT building blocks. As a gesture of respect and
                support, one third of Role’s revenue will be used to collect
                floor price Loot. <br />
                4. In the future, there will be many NFT game projects using the
                underlying contract of Role. It has been determined that the
                Kungfu Hero on-chain NFT game will adopt Role's account system
                in the future. We look forward to cooperating with more projects
                and building Metaverse together.
              </p>
              <div className="brief-img">
                <img src={gender} width="20%" alt="" />
                <img
                  src={skill}
                  width="20%"
                  style={{ marginLeft: "60px" }}
                  alt=""
                />
              </div>
            </div>
          </Grid>
          <Grid item md={6} xs={12}>
            <div className="role-card">
              <img src={logo} width="15%" alt="" />
              <div className="set-attr-area">
                <Grid container spacing={2}>
                  <Grid item lg={6} md={12} xs={12}>
                    <div className="radio-attr">
                      <Grid container spacing={2}>
                        <Grid item md={6} xs={12}>
                          <div className="attr">
                            <div className="attr-value">
                              Gender:{" "}
                              {attributes.gender !== undefined &&
                                genderOptions[attributes.gender].text}
                            </div>
                            <div className="option-area">
                              {genderOptions.map((option, index) => {
                                return (
                                  <label key={index} className="option">
                                    <input
                                      type="radio"
                                      className="options-radio"
                                      value={option.value}
                                      checked={
                                        attributes.gender === option.value
                                      }
                                      onChange={(e) => {
                                        setAttributes({
                                          ...attributes,
                                          gender: Number(e.target.value),
                                        });
                                      }}
                                    />
                                    {option.text}
                                  </label>
                                );
                              })}
                            </div>
                          </div>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className="attr">
                            <div className="attr-value">
                              Race:{" "}
                              {attributes.race !== undefined &&
                                raceOptions[attributes.race].text}
                            </div>
                            <div className="option-area">
                              {raceOptions.map((option, index) => {
                                return (
                                  <label key={index} className="option">
                                    <input
                                      type="radio"
                                      className="options-radio"
                                      value={option.value}
                                      checked={attributes.race === option.value}
                                      onChange={(e) => {
                                        setAttributes({
                                          ...attributes,
                                          race: Number(e.target.value),
                                        });
                                      }}
                                    />
                                    {option.text}
                                  </label>
                                );
                              })}
                            </div>
                          </div>
                        </Grid>
                        <Grid item md={6} xs={12}>
                          <div className="attr">
                            <div className="attr-value">
                              Alignment:{" "}
                              {attributes.alignment !== undefined &&
                                alignmentOptions[attributes.alignment].text}
                            </div>
                            <div className="option-area">
                              {alignmentOptions.map((option, index) => {
                                return (
                                  <label key={index} className="option">
                                    <input
                                      type="radio"
                                      className="options-radio"
                                      value={option.value}
                                      checked={
                                        attributes.alignment === option.value
                                      }
                                      onChange={(e) => {
                                        setAttributes({
                                          ...attributes,
                                          alignment: Number(e.target.value),
                                        });
                                      }}
                                    />
                                    {option.text}
                                  </label>
                                );
                              })}
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                  <Grid item lg={6} md={12} xs={12}>
                    <div className="input-attr">
                      <div className="attr-point-value">
                        Attributes Left Points: {30 - currentPoint}
                      </div>
                      <div className="input-list">
                        {fixPointOrder.map((pointKey) => {
                          return (
                            <div className="point-input" key={pointKey}>
                              <div className="attr-text">{pointKey}:</div>
                              <div className="input-box">
                                <button
                                  className="clac-button"
                                  onClick={() => {
                                    if (
                                      attributes.point[pointKey as point] <= 0
                                    ) {
                                      return;
                                    }
                                    setAttributes({
                                      ...attributes,
                                      point: {
                                        ...attributes.point,
                                        [pointKey]: Number(
                                          attributes.point[pointKey as point] -
                                            1
                                        ),
                                      },
                                    });
                                  }}
                                >
                                  -
                                </button>
                                <input
                                  type="number"
                                  className="attr-input"
                                  value={String(
                                    attributes.point[pointKey as point]
                                  )}
                                  onChange={(e) => {
                                    setAttributes({
                                      ...attributes,
                                      point: {
                                        ...attributes.point,
                                        [pointKey]: Number(e.target.value),
                                      },
                                    });
                                  }}
                                />
                                <button
                                  className="clac-button"
                                  onClick={() => {
                                    if (
                                      attributes.point[pointKey as point] >=
                                        30 ||
                                      currentPoint >= 30
                                    ) {
                                      return;
                                    }
                                    setAttributes({
                                      ...attributes,
                                      point: {
                                        ...attributes.point,
                                        [pointKey]: Number(
                                          attributes.point[pointKey as point] +
                                            1
                                        ),
                                      },
                                    });
                                  }}
                                >
                                  +
                                </button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div
                        className="attr-point-value"
                        style={{ marginTop: "30px" }}
                      >
                        Token ID: {attributes.tokenId}
                      </div>
                      <input
                        type="number"
                        className="attr-input"
                        value={String(attributes.tokenId)}
                        onChange={(e) => {
                          setAttributes({
                            ...attributes,
                            tokenId: Number(e.target.value),
                          });
                        }}
                      />
                      <div className="button-set">
                        <button
                          className="card-button"
                          onClick={() => {
                            randomAttr();
                          }}
                        >
                          Random
                        </button>
                        <button
                          className="card-button"
                          disabled={
                            loading.effects.main.claim ||
                            currentPoint > 30 ||
                            attributes.gender === undefined ||
                            attributes.race === undefined ||
                            attributes.alignment === undefined
                          }
                          onClick={() => {
                            claim(attributes);
                          }}
                        >
                          {/* {!userInfo.address
                    ? "Please connect the wallet first"
                    : loading.effects.main.claim
                    ? "Please wait..."
                    : "Mint"} */}
                          Sold Out
                        </button>
                        <div className="link">
                          <a
                            href="https://opensea.io/collection/role-for-metaverse"
                            target="_blank"
                            rel="noreferrer"
                          >
                            Browse on OpenSea
                          </a>
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
